/** Shared inbox unread count so the sidebar badge survives page remounts. */

const STORAGE_KEY = "inbox_unread_count";

export const readCachedInboxUnread = () => {
  try {
    const n = Number(sessionStorage.getItem(STORAGE_KEY));
    return Number.isFinite(n) && n > 0 ? Math.floor(n) : 0;
  } catch {
    return 0;
  }
};

export const writeCachedInboxUnread = (count) => {
  const n = Math.max(0, Math.floor(Number(count) || 0));
  try {
    sessionStorage.setItem(STORAGE_KEY, String(n));
  } catch {
    /* ignore quota */
  }
  return n;
};

export const publishInboxUnread = (count) => {
  const n = writeCachedInboxUnread(count);
  window.dispatchEvent(
    new CustomEvent("inbox-unread-changed", { detail: { unreadCount: n } })
  );
  return n;
};
